/* ------------------------------------------------------------------
   بردن کاربر به فیلدی که ایراد دارد
   ------------------------------------------------------------------
   🔴 نقصی که این فایل می‌بندد.

   نوشتنِ پیامِ خطا کافی نیست: کاربر جمله را می‌خواند ولی همچنان باید
   در فرمی بلند بگردد تا فیلدِ مربوطه را پیدا کند. «خواندنِ خطا» و
   «رسیدن به فیلد» دو کار جدا بودند.

   ⚠️ نگاشت با `data-field` انجام می‌شود و نه با `id`: در گزارشِ کاری،
   چند ردیفِ تکرارشونده همگی یک ساختار دارند و `id` یکتا برایشان یعنی
   تولید دستیِ رشته در هر `RepeatableSection`؛ `data-field` همان مسیرِ
   خودِ سرور است. در فرم‌های ساده‌تر (مثل ثبت نامه) همان کلیدِ خطای
   محلی روی فیلد می‌نشیند.

   ⚠️ اینجا در `lib` است و نه در یک ماژول: هیچ چیزش به دامنهٔ خاصی
   وابسته نیست و دومین مصرف‌کننده‌اش (ثبت نامه) از ماژولِ دیگری آمد.
   ------------------------------------------------------------------ */

/**
 * ورودیِ متناظر با یک مسیرِ خطای سرور را پیدا می‌کند، به آن اسکرول
 * می‌کند و فوکوس می‌دهد.
 *
 * ⚠️ `anchor` عیناً همان چیزی است که سرور فرستاده
 * (`goals.2.deviation_reason`). المان با `[data-field="..."]` علامت‌گذاری
 * می‌شود؛ اگر خودِ آن المان قابل فوکوس نبود، اولین ورودیِ داخلش
 * انتخاب می‌شود تا `data-field` بتواند روی یک wrapper هم بنشیند.
 *
 * @returns آیا فیلدی پیدا و فوکوس شد
 */
export function focusFieldByAnchor(anchor: string): boolean {
  if (typeof document === 'undefined') return false

  /*
   | ⚠️ `CSS.escape` لازم است: مسیرها نقطه دارند و بدون فرار دادن،
   | `[data-field="goals.2.x"]` را مرورگر درست می‌خواند ولی هر مقدارِ
   | غیرمنتظره‌ای می‌تواند انتخابگر را بشکند.
   */
  const host = document.querySelector<HTMLElement>(`[data-field="${CSS.escape(anchor)}"]`)

  if (!host) return false

  const focusable =
    isFocusable(host) ? host : host.querySelector<HTMLElement>('input, textarea, select, [tabindex]')

  const target = focusable ?? host

  target.scrollIntoView({ behavior: 'smooth', block: 'center' })

  /*
   | فوکوس با `preventScroll` داده می‌شود چون اسکرولِ نرمِ بالا از قبل
   | شروع شده؛ فوکوسِ معمولی آن را با یک پرشِ ناگهانی خراب می‌کند.
   */
  if (isFocusable(target)) {
    target.focus({ preventScroll: true })
    return true
  }

  return false
}

function isFocusable(el: HTMLElement): boolean {
  return (
    el instanceof HTMLInputElement ||
    el instanceof HTMLTextAreaElement ||
    el instanceof HTMLSelectElement ||
    el.tabIndex >= 0
  )
}
